let fontsRequested = false;
const FONT_STYLESHEET_ID = 'byair-google-sans-fonts';
const FONT_STYLESHEET_HREF =
  'https://fonts.googleapis.com/css2?family=Google+Sans:wght@400;500;600;700&display=swap';

const loadFonts = () => {
  if (typeof document === 'undefined') {
    return;
  }

  if (
    document.getElementById(FONT_STYLESHEET_ID) ||
    document.querySelector(`link[href="${FONT_STYLESHEET_HREF}"]`)
  ) {
    return;
  }

  const link = document.createElement('link');
  link.id = FONT_STYLESHEET_ID;
  link.rel = 'stylesheet';
  link.href = FONT_STYLESHEET_HREF;
  link.referrerPolicy = 'no-referrer';
  document.head.appendChild(link);
};

const scheduleFontLoad = () => {
  if (fontsRequested) {
    return;
  }
  fontsRequested = true;

  const startLoading = () => {
    try {
      loadFonts();
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.warn('Font loading failed', error);
      }
    }
  };

  if (typeof window === 'undefined') {
    return;
  }

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(startLoading, { timeout: 2000 });
  } else {
    window.setTimeout(startLoading, 1200);
  }
};

exports.scheduleFontLoad = scheduleFontLoad;
exports.loadFonts = loadFonts;
